import { dataWindmillSpinning } from 'dls-icons-data'
import { createIcon } from '../common'

const IconWindmillSpinning = /*#__PURE__*/createIcon(dataWindmillSpinning)
export default IconWindmillSpinning
